(() => {
  const selector = '[data-zl-community-reviews]';

  const updateCard = (root, copy) => {
    const card = copy.closest('.zl-community-reviews__card');
    const button = card?.querySelector('[data-zl-community-review-toggle]');
    if (!button || copy.classList.contains('zl-community-reviews__copy--expanded')) return;

    button.hidden = !(copy.scrollHeight > copy.clientHeight + 2);
  };

  const initCarouselControls = (root) => {
    const viewport = root.querySelector('.zl-community-reviews__viewport');
    const items = [...root.querySelectorAll('.zl-community-reviews__item')];
    const previous = root.querySelector('[data-zl-community-prev]');
    const next = root.querySelector('[data-zl-community-next]');
    if (!viewport || !previous || !next || items.length < 2) return;

    const targetPosition = (item) => Math.max(0, item.getBoundingClientRect().left - items[0].getBoundingClientRect().left);
    const nearestIndex = () => items.reduce((best, item, index) =>
      Math.abs(targetPosition(item) - viewport.scrollLeft) < Math.abs(targetPosition(items[best]) - viewport.scrollLeft) ? index : best, 0);
    const update = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = viewport.scrollLeft <= 1;
      next.disabled = viewport.scrollLeft >= maxScroll - 1;
    };
    const move = (direction) => {
      const index = Math.min(items.length - 1, Math.max(0, nearestIndex() + direction));
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      viewport.scrollTo({
        left: Math.min(maxScroll, targetPosition(items[index])),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const init = (root) => {
    if (!root || root.dataset.zlCommunityReviewsReady === 'true') return;
    root.dataset.zlCommunityReviewsReady = 'true';
    root.classList.add('zl-community-reviews--ready');
    initCarouselControls(root);

    const copies = [...root.querySelectorAll('[data-zl-community-review-copy]')];

    requestAnimationFrame(() => copies.forEach((copy) => updateCard(root, copy)));

    root.querySelectorAll('[data-zl-community-review-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('.zl-community-reviews__card');
        const copy = card?.querySelector('[data-zl-community-review-copy]');
        if (!copy) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        copy.classList.toggle('zl-community-reviews__copy--expanded', !expanded);
        button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
      });
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => copies.forEach((copy) => updateCard(root, copy)));
      observer.observe(root);
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
